export default "/_next/static/chunks/fonts/Syne Medium-767c33d27d5f99f3ed3e5e572446f774.ttf";